import { render, staticRenderFns } from "./CreateCompany.vue?vue&type=template&id=acddc96e"
import script from "./CreateCompany.vue?vue&type=script&lang=js"
export * from "./CreateCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports